export const STORE_TEMPLATE_ID = 'screen_to_store';

export const isStoreTemplate = template =>
  template?.id === STORE_TEMPLATE_ID || template?.displayName === 'Screen to Store';

export const isAttributionTemplateAvailable = (template, activeFeatures) =>
  isStoreTemplate(template)
    ? activeFeatures?.includes('SCREEN_TO_STORE')
    : activeFeatures?.includes('WEB_ANALYTICS');

export const storeViewIds = {
  exposedDevices: 'store_exposed_devices',
  storeVisits: 'store_visits',
  conversionRate: 'store_conversion_rate',
  attributedVisitors: 'store_attributed_visitors',
  exposedVsVisits: 'store_exposures_vs_visits',
  topSites: 'store_exposure_top_sites',
  topStores: 'store_attribution_top_stores',
  map: 'store_attribution_map'
};

export const storeTemplate = {
  id: STORE_TEMPLATE_ID,
  displayName: 'Screen to Store',
  collection: 'ATTRIBUTION',
  compatibleDatasources: ['MOBILE_M'],
  enabled: true,
  legacyTable: '',
  table: '',
  isCms: false,
  cmsId: '',
  headers: '',
  rows: [
    { widgets: [
      { id: 'store-exposed-devices', url: 'store-exposed-devices.json' },
      { id: 'store-visits', url: 'store-visits.json' },
      { id: 'store-conversion-rate', url: 'store-conversion-rate.json' }
    ] },
    { widgets: [{ id: 'store-exposed-vs-visits', url: 'store-exposed-vs-visits.json' }] },
    { widgets: [
      { id: 'store-top-sites', url: 'store-top-sites.json' },
      { id: 'store-most-visited-stores', url: 'store-most-visited-stores.json' }
    ] },
    { widgets: [{ id: 'store-attribution-map', url: 'store-attribution-map.json' }] }
  ]
};
